import moment from "moment";

import api from "APP_ROOT/api";
import { getPeriodFilters } from "../../utils";

export const request = api.reports.high_scores.sales_stats;

export const columns = [
  {
    key: "period",
    label: "Period",
    render: record => moment(record.period).format("DD-MMM-YY")
  },
  {
    key: "number_of_sales",
    label: "# Sales"
  }
];

export const filters = props => {
  const periodFilters = getPeriodFilters(props);

  return {
    type: "grouped_sales",
    ...periodFilters,
    period: "day",
    order: "number_of_sales"
  };
};

export const color = "#928ff7";



// WEBPACK FOOTER //
// ./app/modules/HighScores/components/StatsTable/getHighestNumberOfSalesOneDay.js